import AuthLayout from '@authentication/components/AuthLayout';
import LoginCard from '@authentication/components/molecules/LoginCard';

function LoginPage() {
  return (
    <AuthLayout>
      <LoginCard />
    </AuthLayout>
  );
}

export default LoginPage;
